import {
    makeStyles 
} from '@mui/styles';
import {
    Box 
} from '@mui/material';
import DataBox from './dataBox';
import Graph from './graph';

type Props = {
    drinksAnswer: number,
    targetDrinksAnswer: number,
    daysAnswer: number,
    targetDaysAnswer: number,
    drinkReduction: number,
    dryDayGain: number;
};

const useStyles = makeStyles(() => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: '8px',
        marginTop: '52px'
    }
}));

export const Charts = ({
    drinksAnswer,
    targetDrinksAnswer,
    daysAnswer,
    targetDaysAnswer,
    drinkReduction,
    dryDayGain 
}: Props): JSX.Element => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <DataBox
                value={drinkReduction}
                label={'Total Drinks Reduced'}
                svg={(
                    <Graph
                        currentValue={drinksAnswer}
                        targetValue={targetDrinksAnswer}
                        type={'drinks'}
                    />
                )}
            />
            {daysAnswer < targetDaysAnswer && (
                <DataBox
                    value={dryDayGain}
                    label={'Dry Days Added'}
                    svg={(
                        <Graph
                            currentValue={daysAnswer}
                            targetValue={targetDaysAnswer}
                            type={'days'}
                        />
                    )}
                />
            )}
        </Box>
    );
};

export default Charts;
